var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35.009,
    viewBox: "0 0 35 35.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M39.089,36.968l-9.734-9.825a13.872,13.872,0,1,0-2.105,2.133l9.67,9.762a1.5,1.5,0,0,0,2.115.055A1.508,1.508,0,0,0,39.089,36.968ZM18.454,29.394A10.954,10.954,0,1,1,26.2,26.185,10.886,10.886,0,0,1,18.454,29.394Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#004f9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search_icon.2016abcca5b3fa355971c83b2a5f9044.svg";
export { ForwardRef as ReactComponent };